// "Load more products": adds the next collection page to the product grid when the shopper clicks the button,
// and keeps the "Showing x of y products" count up to date.
// The plain pagination links stay in the HTML for search engines and for shoppers without JavaScript.
if (!customElements.get('infinite-scroll')) {
  customElements.define(
    'infinite-scroll',
    class InfiniteScroll extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.infinite-scroll__button');
        this.shown = this.querySelector('.infinite-scroll__shown');
        this.loading = false;
        if (!this.button) return;
        this.label = this.button.textContent;
        this.button.addEventListener('click', () => this.loadNext());
      }

      setBusy(busy) {
        this.loading = busy;
        this.button.disabled = busy;
        this.button.toggleAttribute('aria-busy', busy);
        this.button.textContent = busy ? this.dataset.loadingText : this.label;
      }

      async loadNext() {
        const next = this.dataset.nextUrl;
        if (this.loading || !next) return;
        this.setBusy(true);

        try {
          const url = new URL(next, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url);
          if (!response.ok) throw new Error(response.status);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const grid = document.getElementById('product-grid');
          html.querySelectorAll('#product-grid > .grid__item').forEach((item) => {
            // The theme's reveal animation only watches items present at page load, so show new ones directly.
            item.classList.remove('scroll-trigger', 'animate--slide-in');
            grid.appendChild(document.importNode(item, true));
          });
          if (this.shown) this.shown.textContent = grid.querySelectorAll(':scope > .grid__item').length;
          const nextEl = html.querySelector('infinite-scroll');
          this.dataset.nextUrl = (nextEl && nextEl.dataset.nextUrl) || '';
        } catch (error) {
          // Leave the button so the shopper can try again.
          this.setBusy(false);
          return;
        }

        this.setBusy(false);
        if (!this.dataset.nextUrl) this.button.remove();
      }
    }
  );
}
